import {makeStyles} from '@material-ui/core/styles';
export const VProveedorStyle = makeStyles ((theme) => ({
    center:{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    contentMargin:{
        margin: "10px 0",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    }
}));